import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-enterprise-tab-navigator',
  templateUrl: './enterprise-tab-navigator.component.html',
  styleUrls: ['./enterprise-tab-navigator.component.scss']
})
export class EnterpriseTabNavigatorComponent implements OnInit {


  topicTitles = {
    mdm: 'Using Dash with MDM',
    dashboard: 'The web dashboard',
    "dashboard-configuration": 'Configuring Dash',
    "configuration-options": 'Configuration options',
    "analytics": 'Analytics',
    "web-app": 'Dash web app',
    "user-administration": 'User administration'
  };

  navbarOpen = false;
  selectedArticle = null;

  constructor(private route: ActivatedRoute) {

  }

  ngOnInit() {
    let selectedPath = this.route.snapshot.url.pop();
    console.log(selectedPath);
    this.selectedArticle = selectedPath.path;
  }

  toggleNavbar() {
    this.navbarOpen = !this.navbarOpen;
  }

  closeNavbar() {
    this.navbarOpen = false;
  }

  objectKeys = Object.getOwnPropertyNames;

}
